'use client';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import mediaQuery from 'css-mediaquery';
import { FC, ReactNode } from 'react';

const getTheme = (deviceType: string = '') =>
  createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            variants: [
              {
                props: { color: 'default' },
                style: {
                  background: 'var(--neutral-black)',
                  color: 'var(--neutral-white)',
                  lineHeight: '1',
                  '&:hover': {
                    background: 'var(--neutral-800)',
                  },
                },
              },
              {
                props: { color: 'purple' },
                style: {
                  background: 'var(--primary-purple-100)',
                  color: 'var(--neutral-800)',
                  lineHeight: '1',
                  '&:hover, &:active, &[data-state="active"]': {
                    background: 'var(--primary-purple-200)',
                    color: 'var(--neutral-black)',
                  },
                  '&:disabled': {
                    background: 'var(--neutral-300)',
                    color: 'var(---neutral-700)',
                    cursor: 'default',
                  },
                },
              },
              {
                props: { color: 'deep-purple', size: 'large' },
                style: {
                  background: 'var(--primary-purple-500)',
                  color: 'var(--neutral-white)',
                  lineHeight: '24px',
                  '&:hover': {
                    background: 'var(--primary-purple-600)',
                  },
                },
              },
              {
                props: { color: 'deep-purple', size: 'medium' },
                style: {
                  background: 'var(--primary-purple-500)',
                  color: 'var(--neutral-white)',
                  lineHeight: '1',
                  '&:hover': {
                    background: 'var(--primary-purple-600)',
                  },
                },
              },
              {
                props: { color: 'white' },
                style: {
                  background: 'var(--neutral-white)',
                  color: 'var(--neutral-black)',
                  lineHeight: '1',
                  '&:hover': {
                    background: 'var(--neutral-300)',
                  },
                },
              },
            ],
          },
        },
      },
      MuiUseMediaQuery: {
        defaultProps: {
          ssrMatchMedia: (query: string) => {
            return {
              matches: mediaQuery.match(query, {
                // The estimated CSS width of the browser.
                width:
                  { mobile: '0px', tablet: '768px', smallDesktop: '1024px' }[
                    deviceType
                  ] || '1280px',
              }),
            };
          },
        },
      },
    },
  });

export const ThemeContext: FC<{ children: ReactNode; deviceType?: string }> = ({
  children,
  deviceType,
}) => {
  return <ThemeProvider theme={getTheme(deviceType)}>{children}</ThemeProvider>;
};
